import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import { Heart, HeartOff } from "lucide-react";

export interface SaveSelection {
  type: 'save' | 'unsave' | 'mixed';
  savedCount: number;
  unsavedCount: number;
  totalCount: number;
}

interface ShowListHeaderProps {
  title: string;
  totalShows: number;
  sponsorableShows: number;
  selectedCount: number;
  allSponsorableSelected: boolean;
  onSelectAll: (checked: boolean) => void;
  onBulkSaveShows?: () => void;
  isAuthenticated: boolean;
  showBulkActions?: boolean;
  saveSelection?: SaveSelection;
}

export function ShowListHeader({
  title,
  totalShows,
  sponsorableShows,
  selectedCount,
  allSponsorableSelected,
  onSelectAll,
  onBulkSaveShows,
  isAuthenticated,
  showBulkActions = true,
  saveSelection,
}: ShowListHeaderProps) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-6">
      <div className="flex items-center gap-4">
        <h3 className="text-lg font-semibold text-gray-900">
          {title} ({totalShows})
        </h3>
        
        {isAuthenticated && showBulkActions && sponsorableShows > 0 && (
          <div className="flex items-center gap-2">
            <Checkbox
              id="select-all"
              checked={allSponsorableSelected}
              onCheckedChange={onSelectAll}
            />
            <label htmlFor="select-all" className="text-sm font-medium">
              Select All ({sponsorableShows})
            </label>
          </div>
        )}
      </div>
      
      {isAuthenticated && showBulkActions && sponsorableShows > 0 && onBulkSaveShows && (
        <Button
          onClick={onBulkSaveShows}
          disabled={selectedCount === 0}
          className={selectedCount === 0 ? "opacity-50 cursor-not-allowed" : "btn-max-primary"}
          size="sm"
        >
          {saveSelection ? (
            <>
              {saveSelection.type === 'unsave' ? (
                <>
                  <HeartOff className="w-4 h-4 mr-1" />
                  Unsave Selected Shows ({saveSelection.savedCount})
                </>
              ) : saveSelection.type === 'save' ? (
                <>
                  <Heart className="w-4 h-4 mr-1" />
                  Save Selected Shows ({saveSelection.unsavedCount})
                </>
              ) : (
                <>
                  <Heart className="w-4 h-4 mr-1" />
                  Save/Unsave Selected ({saveSelection.unsavedCount}/{saveSelection.savedCount})
                </>
              )}
            </>
          ) : (
            <>
              <Heart className="w-4 h-4 mr-1" />
              Save Selected Shows ({selectedCount})
            </>
          )}
        </Button>
      )}
      
      {!isAuthenticated && showBulkActions && sponsorableShows > 0 && (
        <div className="text-sm text-neutral-600">
          <a href="/login" className="text-primary hover:underline">
            Sign in
          </a> to save shows
        </div>
      )}
    </div>
  );
}